import GrantCheckStep from "./steps/GrantCheckStep";
import ResourceDetailsStep from "./steps/ResourceDetailsStep";
import IntegrationStepV2 from "./steps/IntegrationStepV2";
import EntityObjectConfiguratorStep from "./steps/EntityObjectConfiguratorStep";
import EntitySchemaConfiguratorStep from "./steps/EntitySchemaConfiguratorStep";
import EntitySchemaModeStep from "./steps/EntitySchemaModeStep";
import EntitySourceObjectSelectorStep from "./steps/EntitySourceObjectSelectorStep";
import DestinationConfiguratorStep from "./steps/DestinationConfiguratorStep";
import DestinationDeploymentConfiguratorStep from "./steps/DestinationDeploymentConfiguratorStep";
import DestinationEntityDeploymentConfiguratorStep from "./steps/DestinationEntityDeploymentConfiguratorStep";
import DestinationScheduleConfiguratorStep from "./steps/DestinationScheduleConfiguratorStep";
import EndpointDeploymentConfiguratorStep from "./steps/EndpointDeploymentConfiguratorStep";
import EndpointScopeConfiguratorStep from "./steps/EndpointScopeConfiguratorStep";
import EndpointAuthenticationConfiguratorStep from "./steps/EndpointAuthenticationConfiguratorStep";
import EndpointReadinessStep from "./steps/EndpointReadinessStep";
import ClientMcpToolsConfiguratorStep from "./steps/ClientMcpToolsConfiguratorStep";
import ClientMcpToolsReadinessStep from "./steps/ClientMcpToolsReadinessStep";
import ConvokeAIResourceStep from "./steps/ConvokeAIResourceStep";
import SourceObjectsStep from "./steps/SourceObjectsStep";
import SourceTargetsStep from "./steps/SourceTargetsStep";
import LinkedResourceConfigurationSelectorStep from "./steps/LinkedResourceConfigurationSelectorStep";
import {
  getSectionStepKey,
  getSectionStepUiPatternKey,
  sectionStepExpectsRecord,
  SOURCE_OBJECT_ITEM,
  SOURCE_OBJECT_TARGET_ITEM,
  stepKeysEqual
} from "./resourceConfigWizardUtils";
import SourceSystemStep from "./steps/SourceSystemStep";
import {
  CompleteStep,
  ReviewStep,
  UsageEstimateStep,
  ValidationStep
} from "./steps/PlaceholderSteps";

export const SECTION_STEP_REGISTRY = {
  GrantCheck: GrantCheckStep,
  ResourceDetails: ResourceDetailsStep,
  IntegrationSelector: IntegrationStepV2,
  SourceSystemSelector: SourceSystemStep,
  SourceObjectTargetsConfigurator: SourceTargetsStep,
  SourceObjectConfigurator: SourceObjectsStep,
  EntitySchemaModeSelector: EntitySchemaModeStep,
  EntitySchemaConfigurator: EntitySchemaConfiguratorStep,
  EntitySourceObjectSelector: EntitySourceObjectSelectorStep,
  EntityObjectConfigurator: EntityObjectConfiguratorStep,
  OutboundEdiEntityObjectConfigurator: EntityObjectConfiguratorStep,
  LinkedResourceConfigurationSelector: LinkedResourceConfigurationSelectorStep,
  DestinationConfigurator: DestinationConfiguratorStep,
  DestinationDeploymentConfigurator: DestinationDeploymentConfiguratorStep,
  DestinationEntityDeploymentConfigurator: DestinationEntityDeploymentConfiguratorStep,
  DestinationScheduleConfigurator: DestinationScheduleConfiguratorStep,
  EndpointDeploymentConfigurator: EndpointDeploymentConfiguratorStep,
  EndpointScopeConfigurator: EndpointScopeConfiguratorStep,
  EndpointAuthenticationConfigurator: EndpointAuthenticationConfiguratorStep,
  EndpointValidation: EndpointReadinessStep,
  ClientMcpToolsConfigurator: ClientMcpToolsConfiguratorStep,
  ClientMcpToolsValidation: ClientMcpToolsReadinessStep,
  ConvokeAIProviderConfigurator: ConvokeAIResourceStep,
  ConvokeAIProvisioning: ConvokeAIResourceStep,
  ConvokeAIModelAvailability: ConvokeAIResourceStep,
  ConvokeAIPolicyConfigurator: ConvokeAIResourceStep,
  ConvokeAIValidation: ConvokeAIResourceStep,
  ConvokeAIActivation: ConvokeAIResourceStep,
  DestinationValidation: ValidationStep,
  EntitySchemaValidation: ValidationStep,
  InboundEdiScaffoldValidation: ValidationStep,
  OutboundEdiScaffoldValidation: ValidationStep,
  ConnectionValidation: ValidationStep,
  SourceObjectValidation: ValidationStep,
  UsageEstimate: UsageEstimateStep,
  Review: ReviewStep,
  Complete: CompleteStep
};

export const resolveSectionStepControl = (sectionStep, registry = SECTION_STEP_REGISTRY) => {
  const uiPatternKey = getSectionStepUiPatternKey(sectionStep);
  if (registry !== SECTION_STEP_REGISTRY && registry[uiPatternKey]) {
    return registry[uiPatternKey];
  }
  if (uiPatternKey === "SourceObjectConfigurator") {
    const sectionStepKey = getSectionStepKey(sectionStep);
    if (
      sectionStepExpectsRecord(sectionStep, SOURCE_OBJECT_TARGET_ITEM)
      || stepKeysEqual(sectionStepKey, "source-targets")
    ) {
      return SourceTargetsStep;
    }
    if (
      sectionStepExpectsRecord(sectionStep, SOURCE_OBJECT_ITEM)
      || stepKeysEqual(sectionStepKey, "source-objects")
    ) {
      return SourceObjectsStep;
    }
  }
  return registry[uiPatternKey];
};

export default SECTION_STEP_REGISTRY;
